import Skeleton from "@mui/material/Skeleton";

function MenuSkeleton() {
  return (
    <div className="menu-content">
      {[0, 1].map((col) => (
        <div key={col} className="menu-col">
          {[0, 1, 2].map((section) => (
            <div key={section} className="menu-section">
              <Skeleton variant="text" width="40%" sx={{ fontSize: "1.2rem", mb: 1 }} />
              {[0, 1, 2, 3].map((row) => (
                <Skeleton key={row} variant="text" width="100%" sx={{ fontSize: "1rem" }} />
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default MenuSkeleton;
